import appService from 'src/pl.service';
import { GET_PAYOR_ELIGIBILITIES } from 'src/store/actions/types';
import { buildDeductibles } from './buildDeductibles';

/**
 * retrieves the payor eligibilities from the API and
 * commits the data to the store using the GET_PAYOR_ELIGIBILITIES action type
 */
export const getPayorEligibilities = async ({ commit, state }, applicantId) => {
  commit(GET_PAYOR_ELIGIBILITIES, { loading: true });

  const data = await appService.getPayorEligibilities(
    applicantId ?? state.applicant.id
  );

  const errors = await appService.getEligibilityErrorList(
    applicantId ?? state.applicant.id
  );
  var insuranceVerifyOnlyResponses = [];
  if (data.responses) {
    insuranceVerifyOnlyResponses = data.responses.filter(r => r.isInsuranceVerifierOnly);
    data.responses = data.responses.filter(r => !r.isInsuranceVerifierOnly);

    // Process deductibles for both Discovery and Verifier-only responses
    var allResponses = [...data.responses, ...insuranceVerifyOnlyResponses];
    for (var n = 0; n < allResponses.length; n++) {
      // TODO: refactor patient (left pane) widget to use vuex instead of this
      // if (this.responses[n].createdBy !== 'Realtime Insurance Finder') {
      //   EventBus.$emit('ivStatusRefresh');
      // }

      // TODO: move to template
      // this.responses[n].asOf = this.dateStr(this.responses[n].createdOn);

      allResponses[n].deductibles = buildDeductibles(allResponses[n].benefitInfoes);
    }

    // After processing, split back into Discovery and Verifier-only responses
    data.responses = allResponses.filter(r => !r.isInsuranceVerifierOnly);
    insuranceVerifyOnlyResponses = allResponses.filter(r => r.isInsuranceVerifierOnly);
  }

  commit(GET_PAYOR_ELIGIBILITIES, {
    loading: false,
    retrieved: true,
    data: data.responses,
    ivdata: insuranceVerifyOnlyResponses,
    serviceTypes: data.serviceTypes,
    errors: errors,
  });
};
